import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-组12",
  "use": "icon-组12-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-组12\"><defs><style> </style></defs><g transform=\"translate(-299 -955)\"><g transform=\"translate(299 955)\"><g transform=\"translate(0 0)\"><path class=\"a\" d=\"M307,971a8.024,8.024,0,1,1,5.65-2.35A7.943,7.943,0,0,1,307,971Zm0-14.532A6.532,6.532,0,1,0,313.532,963,6.54,6.54,0,0,0,307,956.468Zm-.734,7.341v-4.656h1.468v4.078l2.365,2.365-1.023,1.023Z\" transform=\"translate(-299 -955)\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol